import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Crown, Check, ArrowLeft } from "lucide-react";

export default function Programa() {
  const [tiers, setTiers] = useState<any[]>([]);
  const [rules, setRules] = useState<any[]>([]);

  useEffect(() => {
    api.get("/tiers").then((r) => setTiers(r.data));
    api.get("/rules").then((r) => setRules(r.data));
  }, []);

  return (
    <div className="min-h-screen bg-obsidian text-slate-900">
      <header className="fixed top-0 inset-x-0 z-50 crystal-glass">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="bg-white rounded-lg px-2 py-1 flex items-center">
              <img src="https://customer-assets-cm19k8pv.emergentagent.net/job_armony-rewards/artifacts/rwv23uh5_image.png" alt="Armony" className="h-6 w-auto" />
            </span>
            <span className="text-xs uppercase tracking-[0.25em] text-slate-500 font-mono hidden sm:block">Contigo</span>
          </Link>
          <Link to="/registro">
            <Button className="gold-gradient-bg text-white font-semibold rounded-full px-5">Unirme</Button>
          </Link>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-6 pt-28 pb-20">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-gold-ink mb-8">
          <ArrowLeft className="w-4 h-4" /> Volver
        </Link>
        <span className="text-xs uppercase tracking-[0.3em] text-gold-ink font-mono">Cómo funciona</span>
        <h1 className="text-4xl sm:text-5xl font-serif font-medium mt-4 mb-4">El Programa Armony Contigo</h1>
        <p className="text-lg text-slate-500 font-light max-w-2xl">
          Acumula puntos con cada interacción, asciende de nivel y disfruta beneficios diferenciados
          diseñados para recompensar tu lealtad.
        </p>

        {/* Rules */}
        <h2 className="text-2xl font-serif font-medium mt-16 mb-6">¿Cómo ganar puntos?</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {rules.map((r) => (
            <div key={r.id} className="card-obsidian p-6">
              <div className="flex items-baseline justify-between mb-2">
                <h3 className="text-base font-semibold text-slate-900">{r.action}</h3>
                <span className="text-gold-ink font-mono font-semibold">+{r.points}</span>
              </div>
              <p className="text-xs text-gold-ink/70 font-mono mb-2">{r.unit}</p>
              <p className="text-sm text-slate-500">{r.description}</p>
            </div>
          ))}
        </div>

        {/* Tiers */}
        <h2 className="text-2xl font-serif font-medium mt-16 mb-6">Niveles y beneficios</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {tiers.map((t) => (
            <div key={t.name} className="card-obsidian p-6 flex flex-col">
              <div
                className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
                style={{ background: t.color + "22", border: `1px solid ${t.color}` }}
              >
                <Crown className="w-5 h-5" style={{ color: t.color }} />
              </div>
              <h3 className="text-xl font-serif font-medium">{t.name}</h3>
              <p className="text-sm text-slate-500 font-mono mb-1">Desde {t.min_points.toLocaleString()} pts</p>
              <p className="text-xs text-gold-ink mb-3">{t.multiplier}x multiplicador</p>
              {t.tagline && <p className="text-xs text-slate-500 mb-4 italic">{t.tagline}</p>}
              <ul className="space-y-2 mt-auto">
                {t.benefits.map((b: string, i: number) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-slate-700">
                    <Check className="w-4 h-4 text-gold shrink-0 mt-0.5" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
